import { render, staticRenderFns } from "./Ratings.vue?vue&type=template&id=04ce2def&scoped=true"
import script from "./Ratings.vue?vue&type=script&lang=js"
export * from "./Ratings.vue?vue&type=script&lang=js"
import style0 from "./Ratings.vue?vue&type=style&index=0&id=04ce2def&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce2def",
  null
  
)

export default component.exports